import React from "react";
import Routes from "./util/routes";
import "./App.scss";
// import HomePage from "./Pages/Home/Home";

function App(props) {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
